module.exports = __webpack_public_path__ + "static/media/Modulesgrey.54622448.svg";